import React, { createContext, useState } from 'react'
import Drawer from '@material-ui/core/Drawer'
import IconButton from '@material-ui/core/IconButton'
import MobileMenu from './MobileMenu'
import styles from '../styles/MobileMenuButton.module.css'
import MobileMenuButtonIcon from './svg/MobileMenuButtonIcon'

export const MobileMenuContext = createContext({
  closeMobileMenu: (): void => {},
})

interface Props {
  dark: boolean;
}

const MobileMenuButton = ({dark = false}: Props): JSX.Element => {
  const [open, setOpen] = useState(false)
  const [opened, setOpened] = useState(false)

  const toggleDrawer = (open: boolean): (() => void) => (): void => {
    if (open) setOpened(true)
    setOpen(open)
  }

  return (
    <MobileMenuContext.Provider
      value={ {
        closeMobileMenu: toggleDrawer(false),
      } }
    >
      <IconButton
        onClick={ toggleDrawer(true) }
        className={ styles.iconButton }
        edge='end'
      >
        <MobileMenuButtonIcon className={styles.button} color={dark ? 'white' : '#191C17'} />
      </IconButton>
      <Drawer
        className={styles.drawer}
        anchor='right'
        open={ open }
        onClose={ toggleDrawer(false) }
        keepMounted={ opened }
      >
        <MobileMenu />
      </Drawer>
    </MobileMenuContext.Provider>
  )
}

export default MobileMenuButton
